/**
 * precise time helper.
 *
 * @copyright Realeyes OU. All rights reserved.
 */

/**
 * Returns current timestamp based on performance timer of browser
 *
 * @return {int}
 */
export default function getCurrentTime() {
    return (typeof window.performance !== 'undefined' && window.performance.now)
        ? window.performance.now()
        : Date.now();
}
